module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nvar field       = model.fields[formMapping.modelFieldIndex];\nvar fieldConfig = field.config || {};\nvar direction   = 'none';\nvar directionClass = '';\nconst langCode    = storage.langCode || 'de-at'\nvar fieldDescription = ((field.lang || {})[langCode] || {}).description || '';\nvar o;\nvar orderPriority = '';\nfor(o in model.resourceFilters.order){\nif(model.resourceFilters.order[o].fieldCode == field.fieldCode){\ndirection       = model.resourceFilters.order[o].direction;\ndirectionClass  = '-' + direction;\nif(model.resourceFilters.order.length > 1){\norderPriority = parseInt(o) + 1;\n}\nbreak;\n}\n}\nvar widthAttribute = '';\nif(fieldConfig.width){\nwidthAttribute = ' width=\"' + field.config.width + '\"'\n}\nvar colSpan = 1;\nvar rowSpan = 1;\nif(fieldConfig.colSpan) colSpan = fieldConfig.colSpan;\nif(fieldConfig.rowSpan) rowSpan = fieldConfig.rowSpan;\nvar additionalClasses = [];\nif(field.fieldCode){\nif(fieldConfig.parentJSONFieldCode){\nadditionalClasses.push(`headOf_${fieldConfig.parentJSONFieldCode}_${field.fieldCode}`);\n} else {\nadditionalClasses.push(`headOf_${field.fieldCode}`);\n}\n}\nif(fieldConfig.textAlign === 'right')       additionalClasses.push('textAlignRight')\nelse if(fieldConfig.textAlign === 'center') additionalClasses.push('textAlignCenter')\nvar isFieldSortable = (config.isSortable && !(config.preventSortOfField || {})[field.fieldCode || 'nonExistingFieldCode']);\n%><td class=\"<%= additionalClasses.join(' ') %>\" colspan=\"<%= colSpan %>\" rowspan=\"<%= rowSpan %>\" data-field-code=\"<%- field.fieldCode %>\" data-order-direction=\"<%- direction %>\"<%- widthAttribute %>><%\n%><div class=\"headContainer\"><%\n%><label><%= ((field || {}).lang[langCode] || {}).label || '' %></label><%\nif(isFieldSortable && directionClass){\n%><div class=\"order\">\n<i class=\"fi fi-sort<%- directionClass %>\"></i>\n<div class=\"orderPriority\"><%- orderPriority || '&nbsp;' %></div>\n</div><%\n}\n%></div><%\nif(fieldDescription){\n%><%- include('../tooltip/tooltip', { model: { message: fieldDescription }, config: {}}); %><%\n}\n%></td>"
  , __filename = "..\\frontend-controller\\baseComponents\\tableSimple\\headCol.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var field       = model.fields[formMapping.modelFieldIndex];
var fieldConfig = field.config || {};
var direction   = 'none';
var directionClass = '';
const langCode    = storage.langCode || 'de-at'
var fieldDescription = ((field.lang || {})[langCode] || {}).description || '';
var o;
var orderPriority = '';
for(o in model.resourceFilters.order){
if(model.resourceFilters.order[o].fieldCode == field.fieldCode){
direction       = model.resourceFilters.order[o].direction;
directionClass  = '-' + direction;
if(model.resourceFilters.order.length > 1){
orderPriority = parseInt(o) + 1;
}
break;
}
}
var widthAttribute = '';
if(fieldConfig.width){
widthAttribute = ' width="' + field.config.width + '"'
}
var colSpan = 1;
var rowSpan = 1;
if(fieldConfig.colSpan) colSpan = fieldConfig.colSpan;
if(fieldConfig.rowSpan) rowSpan = fieldConfig.rowSpan;
var additionalClasses = [];
if(field.fieldCode){
if(fieldConfig.parentJSONFieldCode){
additionalClasses.push(`headOf_${fieldConfig.parentJSONFieldCode}_${field.fieldCode}`);
} else {
additionalClasses.push(`headOf_${field.fieldCode}`);
}
}
if(fieldConfig.textAlign === 'right')       additionalClasses.push('textAlignRight')
else if(fieldConfig.textAlign === 'center') additionalClasses.push('textAlignCenter')
var isFieldSortable = (config.isSortable && !(config.preventSortOfField || {})[field.fieldCode || 'nonExistingFieldCode']);

    ; __line = 39
    ; __append("<td class=\"")
    ; __append(escapeFn( additionalClasses.join(' ') ))
    ; __append("\" colspan=\"")
    ; __append(escapeFn( colSpan ))
    ; __append("\" rowspan=\"")
    ; __append(escapeFn( rowSpan ))
    ; __append("\" data-field-code=\"")
    ; __append( field.fieldCode )
    ; __append("\" data-order-direction=\"")
    ; __append( direction )
    ; __append("\"")
    ; __append( widthAttribute )
    ; __append(">")
    ; 

    ; __line = 40
    ; __append("<div class=\"headContainer\">")
    ; 

    ; __line = 41
    ; __append("<label>")
    ; __append(escapeFn( ((field || {}).lang[langCode] || {}).label || '' ))
    ; __append("</label>")
    ; 
if(isFieldSortable && directionClass){

    ; __line = 43
    ; __append("<div class=\"order\">\n<i class=\"fi fi-sort")
    ; __line = 44
    ; __append( directionClass )
    ; __append("\"></i>\n<div class=\"orderPriority\">")
    ; __line = 45
    ; __append( orderPriority || '&nbsp;' )
    ; __append("</div>\n</div>")
    ; __line = 46
    ; 
}

    ; __line = 48
    ; __append("</div>")
    ; 
if(fieldDescription){

    ; __line = 50
    ; __append( include('../tooltip/tooltip', { model: { message: fieldDescription }, config: {}}) )
    ; 
}

    ; __line = 52
    ; __append("</td>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=..\frontend-controller\baseComponents\tableSimple\headCol.ejs

}